
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Config from "../../../config/main";
import { getGameSubscriptionData } from "../../../helpers/gameMarketsHelpers";
import { UpperScreen } from "../../../actions/terminal";
import Zergling from "../../../../dev/helpers/zergling";
import { hasVideo } from "../../../helpers/sport/videoFilter";
import { getVirtualGameVideo } from "../../../helpers/terminalRequests/virtualSportsHelpers";
import { UIMixin } from "../../../mixins/uiMixin";
import { virtualsVideoStream } from "../../../actions/ui";
import { broadcast, broadcastChannels } from "../../../helpers/broadcast";
import Helpers from "../../../helpers/helperFunctions";

class AnimationWrapper extends Component {
    constructor (props) {
        super(props);
        this.getVideoUrl = this.getVideoUrl.bind(this);
    }

    getVideoUrl (videoId = 1, providerId) {
        return new Promise((resolve, reject) => {
            let request = getVirtualGameVideo(videoId, providerId);
            Zergling.get(request, 'video_url').then((response) => {
                //this.props.dispatch(UpperScreen({type: "VirtualVideo", id: videoId, videoURL: response, tv_type: providerId}));
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    async componentDidMount () {
        const { data, gameType, sportAlias, isVirtualGame, virtualsParams } = this.props;

        if (hasVideo(data) || isVirtualGame) {
            virtualsParams && isVirtualGame && this.props.dispatch(virtualsVideoStream(null));
            this.videoData = await this.getVideoUrl(data.video_id, data.tv_type);
        }

        if (data) {
            const isDualscreen = sessionStorage.getItem("dualscreen");

            if (!Helpers.isSplitScreenAvailable() && isDualscreen !== "true") {
                const params = {
                    url: this.videoData,
                    providerId: data.tv_type,
                    gmaeId: data.id
                };

                data.video_id && this.props.dispatch(virtualsVideoStream(params));
            } else if (Config.upper_screen.live_streaming && (gameType === "live" || isVirtualGame) && this.videoData) {
                Helpers.isSplitScreenAvailable()
                    ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                        detail: { command: 'Video', id: data.id, url: this.videoData, providerId: data.tv_type }
                    })) : this.props.dispatch(UpperScreen({type: "Video", id: data.id, videoURL: this.videoData, tv_type: data.tv_type}));
            } else if (!Config.terminal.disabledAutoOpenGameStatistics && data.is_stat_available &&
                ((Config.upper_screen.statistics_live && gameType === "live") || (Config.upper_screen.statistics_prematch && gameType !== "live"))) {
                Helpers.isSplitScreenAvailable()
                    ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                        detail: { command: 'Statistics', id: data.id, url: "", providerId: 0 }
                    })) : this.props.dispatch(UpperScreen({type: "Statistics", id: data.id, videoURL: "", tv_type: 0}));
            } else if (Config.upper_screen.live_animations && gameType === "live") {
                if (sportAlias === "Soccer" || sportAlias === "Tennis" || sportAlias === 'Basketball') {
                    Helpers.isSplitScreenAvailable()
                        ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                            detail: { command: 'Animation', id: data.id, url: "", providerId: 0 }
                        })) : this.props.dispatch(UpperScreen({type: "Animation", id: data.id, videoURL: "", tv_type: 0}));
                }
            }

            return;
        }
    }
}

AnimationWrapper.propTypes = {
    selectorKey: PropTypes.string,
    data: PropTypes.object,
    userData: PropTypes.object,
    sportAlias: PropTypes.string,
    gameType: PropTypes.string,
    isVirtualGame: PropTypes.bool,
    providerId: PropTypes.number,
    virtualsParams: PropTypes.object,
};

const mapStateToProps = (_, ownParams) => {
    let { selectorKey, gameId } = ownParams;
    return createSelector(
        [
            state => state.swarmData.data[selectorKey] && JSON.stringify(getGameSubscriptionData(state.swarmData.data[selectorKey], gameId)),
            state => state.user && (() => {
                return {
                    loggedIn: state.user.loggedIn && state.user.loggedIn,
                    balance: state.user.profile && state.user.profile.balance
                };
            })(),
            state => state.persistentUIState.expanded && (() => {
                let expandedElements = {};
                expandedElements.gi_score = state.persistentUIState.expanded.gi_score;
                expandedElements.gi_h2h = state.persistentUIState.expanded.gi_h2h;
                expandedElements.gi_stats = state.persistentUIState.expanded.gi_stats;
                expandedElements.gi_timeline = state.persistentUIState.expanded.gi_timeline;
                return expandedElements;
            })(),
            state => state.preferences.lang,
            state => state.uiState.virtualsParams,
        ],
        (data, userData, expandedElements, lang, virtualsParams) => {
            return {
                data: data && JSON.parse(data),
                userData,
                expandedElements,
                lang,
                virtualsParams,
            };
        });
};
export default connect(mapStateToProps)(UIMixin({Component: AnimationWrapper}));